<template>
  <ModalDialog
    v-model="isShow"
    :width="90"
    :closeByClickOutside="true"
    :level="2"
    @close="hideModal()"
  >
    <div class="p-5 field-of-fields" slot="dialog-content">
      <h3>
        Select Candidate for
        {{ addTimeToDate(startDate).toDateString() }}
      </h3>
      <h4 class="mt-2 mb-2" v-if="listAvailableCandidates.length">
        <strong>Available {{ wordUsedForCandidates }}</strong>
      </h4>
      <h4 v-else>
        {{ textSelfSelectNobodyAvailable }}
      </h4>
      <div
        v-for="candidate in listAvailableCandidates"
        :key="'Sorted candidate ' + candidate.id"
        :class="{
          'selected-candidate': hasUnselectCandidateBtn(candidate),
        }"
      >
        <hr />
        <JobFillerInfo
          :jobFiller="candidate"
          :listFields="shiftJobSelectionProfileFields"
          :listAdditionalInfo="candidateInfoSelectionFields"
          :isFavorite="listFavoriteCandidateIds.includes(candidate.id)"
        />
        <div v-if="candidatesCanSetRate && candidate.rate">
          <b>Rate:</b> ${{ candidate.rate }}/h
        </div>
        <button
          v-if="hasUnselectCandidateBtn(candidate)"
          class="btn btn-primary mt-2"
          @click="handleUnselectCandidates(candidate)"
        >
          Unselect
        </button>
        <button
          v-if="hasSelectCandidateBtn(candidate)"
          class="btn btn-primary mt-2"
          @click="listSelectedCandidates.push(candidate)"
        >
          Select
        </button>
      </div>
      <hr />
      <div class="button-container">
        <div class="left-button">
          <button
            class="mylisting-button secondary-button"
            @click="hideModal()"
          >
            {{ getLabelByKeys("BUTTONS.CANCEL") }}
          </button>
        </div>
        <div class="right-button">
          <button
            v-if="bookingIndex < maxBookingIndex"
            class="mylisting-button dark-button"
            @click="handleClickNext()"
          >
            {{ getLabelByKeys("BUTTONS.NEXT") }}
          </button>
          <button
            v-else
            class="mylisting-button dark-button"
            @click="handleClickSubmit()"
          >
            {{ getLabelByKeys("BUTTONS.SUBMIT") }}
          </button>
        </div>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
import ModalDialog from "../../common/global-dialogs/ModalDialog.vue";
import JobFillerInfo from "../JobFillerInfo.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "SelectFillerDialog",
  props: {
    // Status of dialog: Open, close
    value: Boolean,
    listDateTimesOfJobs: Array,
    bookingInfo: Object,
    listCandidates: Array,
    listRelatedAvailabilities: Array,
    weekAvailabilities: Array,
    listRelatedJobs: Array,
    listFavoriteCandidateIds: Array,
  },
  components: {
    ModalDialog,
    JobFillerInfo,
  },
  data() {
    return {
      isShow: false,
      bookingIndex: 0,
      listSelectedCandidates: [],
      mapSelectedCandidates: {},
    };
  },
  computed: {
    ...mapGetters([
      "shiftJobSelectionProfileFields",
      "candidateInfoSelectionFields",
      "clientCanSelectMultipleCandidates",
      "wordUsedForCandidates",
      "textSelfSelectNobodyAvailable",
      "candidatesCanSetRate",
    ]),
    maxBookingIndex() {
      const listIndex = this.listDateTimesOfJobs.map(
        (dateTime) => dateTime.index
      );
      return Math.max(...listIndex);
    },
    listSelectedDateTime() {
      return this.listDateTimesOfJobs.filter(
        (dateTime) => dateTime.index === this.bookingIndex
      );
    },
    startDate() {
      if (!this.listSelectedDateTime || !this.listSelectedDateTime.length) {
        return "";
      }
      return this.listSelectedDateTime[0].date;
    },
    listAvailableCandidates() {
      if (!this.isShow) {
        // Dialog is not showed
        return [];
      }
      const booking = {
        ...this.bookingInfo,
        date: this.startDate,
      };
      return this.listCandidates.filter((candidate) => {
        return (
          !this.isAvailabilityConflict(
            candidate,
            this.listRelatedAvailabilities,
            this.weekAvailabilities || [],
            this.listSelectedDateTime
          ) &&
          !this.isTimeConflict(candidate, this.listRelatedJobs, booking) &&
          !this.isTimeOffConflict(
            candidate,
            this.listRelatedAvailabilities,
            this.listSelectedDateTime
          ) &&
          !this.isExceedMaxJobDaily(
            candidate,
            this.listRelatedJobs,
            booking,
            this.listSelectedDateTime
          )
        );
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.showModal();
        } else {
          this.hideModal();
        }
      },
    },
    isShow: {
      immediate: true,
      handler() {
        this.$emit("input", this.isShow);
      },
    },
  },
  methods: {
    hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal() {
      this.isShow = true;
    },
    hasUnselectCandidateBtn(candidate) {
      return this.listSelectedCandidates.some(
        (cand) => cand.id === candidate.id
      );
    },
    hasSelectCandidateBtn(candidate) {
      if (this.clientCanSelectMultipleCandidates) {
        return !this.listSelectedCandidates.some(
          (cand) => cand.id === candidate.id
        );
      } else {
        return !this.listSelectedCandidates.length;
      }
    },
    handleUnselectCandidates(candidate) {
      this.listSelectedCandidates = this.listSelectedCandidates.filter(
        (cand) => cand.id !== candidate.id
      );
    },
    handleClickNext() {
      this.mapSelectedCandidates[this.startDate] =
        this.listSelectedCandidates.map((candidate) => candidate.id);
      this.bookingIndex += 1;
      this.listSelectedCandidates = [];
    },
    handleClickSubmit() {
      this.mapSelectedCandidates[this.startDate] =
        this.listSelectedCandidates.map((candidate) => candidate.id);
      this.$emit("selected", this.mapSelectedCandidates);
      this.hideModal();
    },
  },
};
</script>

<style scoped>
.selected-candidate {
  background-color: rgb(227 226 226);
}

.button-container {
  display: flex;
}

.left-button {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/common/bookings/SelectFillerDialog.vue